enum PriceDisplayOption {
  WITH_VAT = 'WITH_VAT',
  WITHOUT_VAT = 'NO_VAT',
  HIDDEN = 'HIDE_PRICE',
}

export default PriceDisplayOption;
